import { useRef } from 'react'
import styles from './TheProblem.module.css'

const ValueProposition = () => {
  const sectionRef = useRef<HTMLElement>(null)

  return (
    <section ref={sectionRef} id="the-problem" className={styles.section}>
      <div className={styles.ambientLeft} />
      <div className={styles.ambientRight} />

      <div className="container">
        <div className={styles.layout}>

          <div className={styles.labelColumn}>
            <div className={styles.sectionTag}>
              <span className={styles.tagNumber}>01</span>
              <span className={styles.tagLine} />
              <span className={styles.tagText}>The Problem</span>
            </div>
          </div>

          <div className={styles.contentColumn}>
            <p className={styles.openingStatement}>
              Why do AI-assisted coding tools so often feel like they're working against you?
            </p>

            <p className={styles.bodyText}>
              The suggestion that's almost right but costs you ten minutes to untangle. The
              completion delivered with total confidence that turns out to be completely wrong.
              The persistent, unsettling feeling that something is reading your code without
              actually understanding what you're trying to build. This is the everyday reality
              of working with most AI coding tools, and it's left developers carrying a
              justified skepticism into every new product that promises to be different.
            </p>
            <span className={styles.buildLine}>That skepticism is earned — and it's exactly the problem we built Box Editor to solve.</span>
          </div>

        </div>
      </div>
    </section>
  )
}

export default ValueProposition
